import React, { FC } from 'react';

import { FormattedMessage } from 'react-intl';

import { IdEnums } from '@nhl/nhl-breakaway-ui';

import CommonMessages from '~/core/commonMessages';

type Props = {
    gameNumber: number;
    seriesAbbrev: string;
};

const FormattedRoundAndGame: FC<Props> = ({ gameNumber, seriesAbbrev }) => {
    const roundDescription = CommonMessages.playoffRoundDescriptions.long[seriesAbbrev];

    return (
        <FormattedMessage
            {...CommonMessages.playoffGameDescriptions.descriptions.roundAndGame}
            values={{
                game: (
                    <FormattedMessage
                        {...CommonMessages.playoffGameDescriptions.abbreviations.game}
                        values={{ gameNumber }}
                    />
                ),
                round: roundDescription ? (
                    <FormattedMessage {...roundDescription} />
                ) : (
                    <FormattedMessage {...CommonMessages.gameTypeDescriptions.short[IdEnums.GameType.playoffs]} />
                ),
            }}
        />
    );
};

export default FormattedRoundAndGame;
